<template>
  <v-layout class="home-footer-info" style="flex: none; height: 100%">
    <div id="projection">{{ $tc("Projection", 1) }}:</div>

    <v-menu top offset-y>
      <template v-slot:activator="{ on }">
        <div v-on="on" id="projection-data">
          {{ projectionLabel }}
        </div>
      </template>

      <v-list dense class="pa-0" style="font-size: 10px; text-align: start;">
        <v-list-item
          v-for="(item, index) in projectionOptions"
          :key="index"
          @click="selectProjection(item)"
        >
          <v-list-item-title>
            {{ item.label }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-layout>
</template>

<script>
import { bus } from "@/main";
import { mapActions } from "vuex";

export default {
  name: "HomeFooterProjection",

  computed: {
    projectionLabel() {
      let projectionID = this.$store.getters.getSelectedProjection;
      let projection = this.projectionOptions.find(
        item => item.id === projectionID
      );
      if (projection) {
        return projection.label;
      }
      return projectionID;
    },

    projectionOptions() {
      let projectionOptions = [];
      let projections = this.$store.getters.optionLists_projections;
      if (projections) {
        projections.forEach(projection => {
          projectionOptions.push({
            id: projection.code,
            label: projection.code + " : " + projection.definition
          });
        });
      }
      return projectionOptions;
    }
  },

  methods: {
    ...mapActions(["SET_ACTIVE_PROJECTION"]),

    selectProjection(projection) {
      this.SET_ACTIVE_PROJECTION(projection.id);
      bus.$emit("update-projection", projection.id);
    }
  }
};
</script>

<style scoped>
#projection {
  border-right: none;
}

#projection-data {
  border-left: none;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Footer/Projection.vue